module.exports = __webpack_public_path__ + "static/media/julian_alvarez.36c33240.jpg";